// extracted by mini-css-extract-plugin
module.exports = {"container":"az_jxc","textContainer":"az_kxc","title":"az_lxc","subtitle":"az_mxc"};